import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeysCompany } from '../queryKeys';

import { createCompanyAliasAddress } from './createCompanyAliasAddress';
import {
  type CreateCompanyAliasAddressMutationOptions,
  type CreateCompanyAliasAddressPayload,
} from './types';

/**
 * Custom hook for creating a company alias address using mutations.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin-Company-Alias-Addresses/operation/create_company_address_vadmin_company_alias_address_post
 */
export const useMutationCreateCompanyAliasAddress = (
  options?: CreateCompanyAliasAddressMutationOptions,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: CreateCompanyAliasAddressPayload) =>
      createCompanyAliasAddress(payload),
    onSettled(_data, _error, { companyId }) {
      void queryClient.invalidateQueries({
        queryKey: queryKeysCompany.getAliasAddresses({
          // limit: PAGINATION_PAGE_SIZE_DEFAULT,
          // offset: 0,
          // companyId,
        }),
      });
    },
    ...options,
  });
};
